/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormsModule, ReactiveFormsModule } from '@angular/forms';
// Core
import { ControlComponent } from '../../core/component/control.component';
import { NgcErrorModule } from '../error/ngc-error.component';
// JQX Widget
import { jqxPasswordInputComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxpasswordinput';

// Control Value Accessor
const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NgcPasswordInputComponent),
    multi: true
};

/**
 * Password Input
 */

export class NgcPasswordInputComponent extends ControlComponent {
     localization: any;
     maxLength: any;
     placeHolder: any;
     passwordStrength: any;
     rtl: any;
     strengthColors: any;
     showStrength: any;
     showStrengthPosition: any;
     strengthTypeRenderer: any;
     showPasswordIcon: any;
     theme: any;
     width: any;
     height: any;
     autoCreate: boolean = true;

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }

    /**
     * On Input Change
     * 
     * @param Event
     */
    inputChange($e) {
        this.value = $e.target.value;
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ngc-passwordinput',
    template: `<jqxPasswordInput *ngIf="visible" (input)="inputChange($event)"
                [disabled] = "disabled"
                [localization] = "localization"
                [maxLength] = "maxLength"
                [placeHolder] = "placeHolder"
                [passwordStrength] = "passwordStrength"
                [rtl] = "rtl"
                [strengthColors] = "strengthColors"
                [showStrength] = "showStrength"
                [showStrengthPosition] = "showStrengthPosition"
                [strengthTypeRenderer] = "strengthTypeRenderer"
                [showPasswordIcon] = "showPasswordIcon"
                [theme] = "theme"
                [width] = "width"
                [height] = "height">
                </jqxPasswordInput>
                <ngc-error *ngIf="visible" [value]="error"></ngc-error>
                `,
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NgZone, },
{type: ElementRef, },
{type: Renderer, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'localization': [{ type: Input, args: ['localization', ] },],
'maxLength': [{ type: Input, args: ['maxLength', ] },],
'placeHolder': [{ type: Input, args: ['placeHolder', ] },],
'passwordStrength': [{ type: Input, args: ['passwordStrength', ] },],
'rtl': [{ type: Input, args: ['rtl', ] },],
'strengthColors': [{ type: Input, args: ['strengthColors', ] },],
'showStrength': [{ type: Input, args: ['showStrength', ] },],
'showStrengthPosition': [{ type: Input, args: ['showStrengthPosition', ] },],
'strengthTypeRenderer': [{ type: Input, args: ['strengthTypeRenderer', ] },],
'showPasswordIcon': [{ type: Input, args: ['showPasswordIcon', ] },],
'theme': [{ type: Input, args: ['theme', ] },],
'width': [{ type: Input, args: ['width', ] },],
'height': [{ type: Input, args: ['height', ] },],
'autoCreate': [{ type: Input, args: ['auto-create', ] },],
};
}

/**
 * Password Input Module
 */

export class NgcPasswordInputModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, FormsModule, ReactiveFormsModule, NgcErrorModule],
    exports: [NgcPasswordInputComponent],
    declarations: [NgcPasswordInputComponent, jqxPasswordInputComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
